// This file was automatically generated from appchart.dialog.ordermed.ignoreIntxnReason.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.ordermed.ignoreIntxnReason');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.ignoreIntxnReason.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form id="ignore-intxn-reason-form"><div class="overlayContainer"><span class="intxn-details"></span><div class="el8TextareaWrap"><textarea type="text" class="w100" rows="5" name="ignoreIntxnReason"></textarea></div><div class="el8Wrap"><label class="el8label add-prescription-note checkMark"><input type="checkbox" class="options" name="addToPrescriptionNote" />Add note to prescription?</label></div></div></form>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.ignoreIntxnReason.intxnDetails = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8Wrap"><p class="el8AppText lgFont">');
  if (opt_data.type == 'drugDrug') {
    output.append('Contra-indicated for ');
    var intxList1950 = opt_data.interactions;
    var intxListLen1950 = intxList1950.length;
    for (var intxIndex1950 = 0; intxIndex1950 < intxListLen1950; intxIndex1950++) {
      var intxData1950 = intxList1950[intxIndex1950];
      var drugList1951 = intxData1950.drugs;
      var drugListLen1951 = drugList1951.length;
      for (var drugIndex1951 = 0; drugIndex1951 < drugListLen1951; drugIndex1951++) {
        var drugData1951 = drugList1951[drugIndex1951];
        output.append(soy.$$escapeHtml(drugData1951), (drugIndex1951 == drugListLen1951 - 1) ? '. ' : ', ');
      }
    }
  } else {
    output.append('Contra-indicated for patient with allergies to ');
    var intxList1962 = opt_data.interactions;
    var intxListLen1962 = intxList1962.length;
    for (var intxIndex1962 = 0; intxIndex1962 < intxListLen1962; intxIndex1962++) {
      var intxData1962 = intxList1962[intxIndex1962];
      var allergyList1963 = intxData1962.allergies;
      var allergyListLen1963 = allergyList1963.length;
      for (var allergyIndex1963 = 0; allergyIndex1963 < allergyListLen1963; allergyIndex1963++) {
        var allergyData1963 = allergyList1963[allergyIndex1963];
        output.append(soy.$$escapeHtml(allergyData1963), (allergyIndex1963 == allergyListLen1963 - 1) ? '. ' : ', ');
      }
    }
  }
  output.append('</p></div>');
  if (!opt_sb) return output.toString();
};
